import {
  AuthorizedUiElementConfig,
  AuthorizedUiElementService,
} from "../../../../ui/authorizedUiElement";
import { MultipleMachineChangeChildStateConfig } from "./multipleProvider";

export abstract class MachineChangeComponentController<
  TElementConfig extends AuthorizedUiElementConfig
> {
  constructor(
    readonly childStateService: AuthorizedUiElementService<TElementConfig>
  ) {}

  getChildren(): MultipleMachineChangeChildStateConfig[] {
    return this.childStateService.getConfigs();
  }
}
